module.exports = __webpack_public_path__ + "static/media/empf prototype.4c0bd0b5.gif";